import React, { useEffect, useState } from 'react';
import { Search } from '../../../components/UI/console/Form';
import SearchMark from '../../../components/UI/SearchMark';
import { Modal } from "react-bootstrap";
import { _API } from '../../../modules/utils';
import useStore from '../../../modules/utils/store';
import moment from "moment";

export default function ConnectUsersViewModalBase(props){
    const { siteInfo } = useStore();
    const { consoleCfg, showConnectUsersViewModal, setShowConnectUsersViewModal, messages } = props;
    const [connectUsers, setConnectUsers] = useState(null);
    const [keyword, setKeyword] = useState('');

    const now = () => moment().format('YYYY-MM-DD HH:mm:ss');

    const getConnectUsers = () => {
        _API.post({
            path: "/v1/client/console/user/list",
            data: {
              siteIdx: siteInfo?.siteIdx,
              eventIdx: consoleCfg?.eventIdx,
              sessionIdx: consoleCfg?.sessionIdx,
              consoleIdx: consoleCfg?.consoleIdx,
            },
        }).then((res) => {
            setConnectUsers(res.data);
        });
    };

    const filteredUsers = connectUsers?.filter((u) => (
        u?.preregIdx?.toString()?.includes(keyword) ||
        u?.name?.toString()?.includes(keyword) ||
        u?.passCode?.toString()?.includes(keyword) ||
        u?.companyName?.toString()?.includes(keyword) ||
        u?.deptName?.toString()?.includes(keyword)
    )) || [];

    const refreshButton = (e) => {
        e.target.text = `(${now()}) ${messages.refresh}`;
        setConnectUsers(null);
        getConnectUsers();
    };

    useEffect(() => {
        if (showConnectUsersViewModal == true) {
            getConnectUsers();
        }
    }, [showConnectUsersViewModal]);

    const handleClose = () => {
        setConnectUsers(null);
        setShowConnectUsersViewModal(false);
    };

    const summaryText = messages.totalSuffix
        ? (
            <span>
                {messages.totalPrefix} <b>{connectUsers?.length || 0}</b>{messages.totalSuffix}
                <b>{filteredUsers.length}</b>{messages.filteredSuffix}
            </span>
        )
        : (
            <span>
                {messages.totalPrefix} <b>{filteredUsers.length}</b> {messages.filteredSuffix} <b>{connectUsers?.length || 0}</b> total
            </span>
        );

    return(
        <Modal
            show={showConnectUsersViewModal}
            onHide={handleClose}
            backdrop="static"
            className="survey_container"
            style={{zIndex:"1051"}}
        >
            <div className="ft_modal_header">
                <div>
                    <h2>{messages.title}</h2>
                    <button className="close_btn" onClick={handleClose}>
                        <img src="https://cdn.onoffevent.com/common/icon_close.svg" />
                    </button>
                </div>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-4 pl-5 pr-5">
                {summaryText}
                <div style={{display:"flex",gap:"10px",alignItems:"center"}}>
                    <button onClick={(e) => refreshButton(e)}>
                        ({messages.lastUpdate}&nbsp;:&nbsp;{now()})&nbsp;{messages.refresh}
                    </button>
                    <Search type="text" value={keyword} onChange={(e) => setKeyword(e?.target?.value || '')} delButton/>
                </div>
            </div>
            <div className="ft_modal_content" style={{paddingTop:'0px',marginTop:'15px'}}>
                <table className="question_storage_table">
                    <thead>
                        <tr align="center" height="34">
                            <th width="10%" style={{position:'sticky', top:'-1px'}}>{messages.participantId}</th>
                            <th width="15%" style={{position:'sticky', top:'-1px'}}>{messages.name}</th>
                            <th width="15%" style={{position:'sticky', top:'-1px'}}>{messages.accessAccount}</th>
                            <th width="20%" style={{position:'sticky', top:'-1px'}}>{messages.hospitalName}</th>
                            <th width="20%" style={{position:'sticky', top:'-1px'}}>{messages.department}</th>
                            <th width="20%" style={{position:'sticky', top:'-1px'}}>{messages.connectedAt}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!connectUsers || connectUsers?.length <= 0 ? (
                            <tr><td className="text-center" colSpan="6">{messages.empty}</td></tr>
                        ) : (
                            <>
                                {filteredUsers.map((item,i) => (
                                    <tr align="center" key={i}>
                                        <td><SearchMark text={item?.preregIdx} keyword={keyword}/></td>
                                        <td><SearchMark text={item?.name} keyword={keyword}/></td>
                                        <td><SearchMark text={item?.passCode} keyword={keyword}/></td>
                                        <td><SearchMark text={item?.companyName || '-'} keyword={keyword}/></td>
                                        <td><SearchMark text={item?.deptName || '-'} keyword={keyword}/></td>
                                        <td>{item?.startedAt && moment(item?.startedAt).format('YYYY-MM-DD HH:mm:ss')}</td>
                                    </tr>
                                ))}
                            </>
                        )}
                    </tbody>
                </table>
            </div>
        </Modal>

    )
}
